import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TextInput from "@/components/inputs/TextInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileNumber',
  props: {
    modelValue: {
        default: null,
        required: true,
    },
    name: {
        type: String,
        default: null,
    },
    id: {
        type: String,
        default: null,
    },
    error: {
        type: String,
        default: null,
    },
    placeholder: {
        type: String,
        default: "Mobile Number",
    },
    isRequired: {
        type: Boolean,
        default: false,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {



const numberonly = (e) => {
    e = e ? e : window.event;
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
    } else {
        return true;
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextInput, {
    type: "number",
    name: __props.name,
    id: __props.id,
    onKeypress: numberonly,
    placeholder: __props.placeholder,
    maxlength: 11,
    value: __props.modelValue,
    error: __props.error,
    required: __props.isRequired,
    readonly: __props.readonly
  }, null, 8, ["name", "id", "placeholder", "value", "error", "required", "readonly"]))
}
}

})